module.exports = __webpack_public_path__ + "static/media/value-poster-1.9167e651.png";